import React from "react";

interface BookingCalendarProps {
  availableSlots: string[];
  loadingSlots: boolean;
  selectedSlot: string | null;
  setSelectedSlot: (slot: string | null) => void;
  isDoctorSelected: boolean;
}

function BookingCalendar({
  availableSlots,
  loadingSlots,
  selectedSlot,
  setSelectedSlot,
  isDoctorSelected,
}: BookingCalendarProps): React.JSX.Element {
  return (
    <div className="w-full rounded-lg border border-slate-200 shadow-sm bg-white p-6">
      <h2 className="text-base font-bold text-slate-700 uppercase tracking-wider mb-4 border-b border-slate-200 pb-3">
        Διαθέσιμες Ώρες Ραντεβού
      </h2>

      {!isDoctorSelected ? (
        <p className="text-sm text-slate-500 text-center py-8">
          Παρακαλώ επιλέξτε πρώτα γιατρό από τα αριστερά.
        </p>
      ) : loadingSlots ? (
        <p className="text-sm text-slate-500 text-center py-8">
          Φόρτωση διαθέσιμων ωρών...
        </p>
      ) : availableSlots.length === 0 ? (
        <p className="text-sm text-slate-500 text-center py-8">
          Δεν υπάρχουν διαθέσιμα ραντεβού για αυτή την ημερομηνία και τον
          γιατρό.
        </p>
      ) : (
        <div className="grid grid-cols-2 gap-3">
          {availableSlots.map((slot) => (
            <button
              key={slot}
              type="button"
              onClick={() => setSelectedSlot(slot)}
              className={`p-3 text-sm font-medium rounded-md border transition-all ${
                selectedSlot === slot
                  ? "bg-primary text-white border-primary shadow-sm"
                  : "bg-white text-slate-700 border-slate-300 hover:bg-slate-50"
              }`}
            >
              {slot}
            </button>
          ))}
        </div>
      )}
    </div>
  );
}

export default BookingCalendar;
